export default "__VITE_ASSET__CobxofCA__"